// TODO: Review AI Code for feature: System Landscape & Interactions Visualization - Entire file is AI-generated
import { SystemLandscapeResponseSchema } from './get-system-landscape.schema';
import { z } from 'zod';
/**
 * Get System Landscape Endpoint Contract
 * Retrieves aggregated system landscape for the organization
 */ export const getSystemLandscapeContract = {
    method: 'GET',
    path: '/api/v2/system/landscape',
    description: 'Retrieve the organization-wide system landscape with aggregated metrics',
    requestSchema: z.object({}),
    responseSchema: SystemLandscapeResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated'
        }
    }
};

//# sourceMappingURL=get-system-landscape.contract.js.map